import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b1546534&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=b1546534&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=b1546534&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1546534",
  null
  
)

export default component.exports